import React from 'react'

import { connect } from 'react-redux'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import ToastBar from '../../component/toast/toast.js'
import './gift-alert.css'
import {userList} from '../../redux/chatuser.redux.js'
import {getUnReadNum} from '../../redux/chatuser.redux.js'

import {getNewGameIndex} from '../../redux/newGame.redux.js'
import {getLoginURL} from '../../util.js'
import { Link} from "react-router-dom"
import {getGiftSuccessCallBack} from  '../../redux/chatuser.redux.js'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,getUnReadNum,getGiftSuccessCallBack}
)
@connect(
  state=>state.newGame,
  {getNewGameIndex}
)


class GiftAlert extends React.Component{
	constructor(props){
		super(props)
		 this.state={
	    
	      visible:false,
	      showSelectWelfare:false,
	      showGetSuccess:false,
	      successMsg:'',
	      getAreas:null,
	      getServer:'',
	      platform:'' ,
	      giftData:'',
	      characterName:null,
	      equip:1,
	      giftDetail:'',	     
	      price:'1',	  	    
	      ScoreNotice:false,
	 	  payType:1,
	      goodsPrice:'',
	      giftTotalMoney:'',
	      userCoupon:'--',
	      couponNum:'',
	      ifSuccessGet:false,
	      alertNotice:false,
	      alertCode:false,
	      gradeLow:false,
	      showLoading:false,
	      solveFuNum:0
		    		    
	    }
	   
	  
	   this.AreaId = null
	   this.groupId = null
	   this.roleName = null
	   this.character_id =null	  
	   this.alertMsg="领取成功"
	   this.userInp=''
	   this.payTypeOff = true
	   this.ifSuccessGetNum1=false
	   this.ifSuccessGetNum2=false
	   this.ifPhone = false
	   this.ToastBarClose = this.ToastBarClose.bind(this)
	   this.caiGameId= this.props.match.params.id
	}

	componentDidMount(){
		this.caiGameId= this.props.match.params.id
    	
    	this.setState({
    		visible:this.props.visible,
    		showSelectWelfare:this.props.showSelectWelfare,
    		showGetSuccess:this.props.showGetSuccess,
    		giftData:this.props.giftData
    		
    	})
    	if(document.documentElement.clientWidth<600){
    		this.ifPhone = true
    	}else{
    		this.ifPhone  = false
    	}
    	this.handleArea()
    	this.handleGiftDetail()
    	
    
  	}
  	
  	handleGiftDetail(){
		
  		axios.get('/fapi/users/getItemInfo?id='+this.props.giftData.id+'')
  			.then((res)=>{
  				
  				if(res.data.return_code===0){
					
  					var idata = res.data.data
  					
					this.setState({

						giftDetail:res.data.data,
						iScore:res.data.data.score,
						iCoupon:res.data.data.coupon,
						platform:res.data.data.game_platform,
						
						alertNotice:false,
						alertCode:false,
						gradeLow:false
						

					},function(){
						this.payTypeFn()
					})	
				}
				
  			})
		
  	}
  	comonPayMode(mdata,num){
  		var idata = mdata
  		var iPrice = ''
  		var  totalOff= Number(idata.isDota)+Number(idata.isCurrency)+Number(idata.isBoth)

  		if(totalOff===1){
  			if(Number(idata.isDota)){

				iPrice = idata.score*num +'积分'
	  		}
	  		if(Number(idata.isCurrency)){

	  			iPrice = idata.coupon*num +'点券'
	  		} 
	  		if(Number(idata.isBoth)){

	  			iPrice = idata.score*num +'积分'+'（或'+idata.coupon*num+'点券）'
	  		} 

  		}else{
  			iPrice = idata.score*num +'积分'+'（或'+idata.coupon*num+'点券）'
  		}
  		
  		
		return {
			score:this.state.giftDetail.score,
			coupon:this.state.giftDetail.coupon,
			iPrice:iPrice
		} 
  	}
  	ToastBarClose(data){
  		
  		this.setState({
	  		showWrongAlert:false,
	  			
	  	})
  	}
  	handleArea(){
  		
		axios.get('/fapi/users/getAreas/'+this.props.giftData.id+'?platform='+this.state.equip+'')
  			.then(res=>{
  				
  				if(res.data.return_code===0){

  					if(res.data.data.platform===1){
						this.setState({											
							getAreas:res.data.data.areaList																					
						})
						this.AreaId = res.data.data.areaList[0].area_id
						this.handleServer(this.props.giftData.id,res.data.data.areaList[0].area_id)
  					}
  					if(res.data.data.platform===2){
						this.setState({											
							getAreas:[
								{
									"area_name":'IOS'
								},
								{
									"area_name":'安卓'
								}
							],
							getServer:res.data.data.areaList																			
						})
						this.AreaId = res.data.data.areaList[0].area_id
						//this.handleServer(this.props.giftData.id,res.data.data.areaList[0].id)
						this.handleRole(this.props.giftData.id,'',res.data.data.areaList[0].area_id)
  					}
					
					
				}
  			})
  	}
  	handleChangeArea(e,id){
		const AreaId = e.target.options[e.target.options.selectedIndex].getAttribute('_id')
		var  equip = e.target.options[e.target.options.selectedIndex].getAttribute('_platform')
		
		if(this.state.platform===2){
			this.setState({
				equip:equip
				
			},function () {
				this.handleArea()
			})
		}else {
			
		}
		this.AreaId = AreaId
		
		this.handleServer(this.props.giftData.id,AreaId)
		
		
  	}
  	handleChangeServer(e,id){
		const ServerId = e.target.options[e.target.options.selectedIndex].getAttribute('_id')
		
		if (this.state.platform === 2) {
			this.AreaId = ServerId
		}else {
			this.groupId = ServerId
		}
		
		this.handleRole(this.props.giftData.id,this.AreaId,ServerId)
  	}
  	handleChangeRole(e){
		this.roleName = e.target.options[e.target.options.selectedIndex].getAttribute('_name')
		this.character_id = e.target.options[e.target.options.selectedIndex].getAttribute('_id')
  	}
  
  	handleServer(gameId,AreaId){
		axios.get('/fapi/users/getServers/'+gameId+'_'+AreaId+'')
  			.then(res=>{
  				
  				if(res.data.return_code===0){
  					
					this.setState({											
						getServer:res.data.data,
						solveFuNum:this.state.solveFuNum+1																					
					})
					this.groupId = res.data.data[0].id
					this.handleRole(gameId,AreaId,res.data.data[0].id)
				}
  			})
  	}
  	handleRole(gameId,AreaId,serverId){
  		
  		if(this.state.platform===2){
			
  			var myUrl = '/fapi/users/getRoles?id='+gameId+'&&area_id='+serverId+'&&platform='+this.state.equip+''

  		}else {
  			
  			var myUrl = '/fapi/users/getRoles?id='+gameId+'&&area_id='+AreaId+'&&server_id='+serverId+''
  		}
  		axios.get(myUrl)
  			.then(res=>{
  				
  				if(res.data.return_code===0){
					this.setState({
						characterName:res.data.data
					})
					 this.roleName = res.data.data.length===0?null:res.data.data[0].character_name
  					 this.character_id = res.data.data.length===0?null:res.data.data[0].character_id
  						if(!this.roleName){

  							
				  			this.ifSuccessGetNum1=false
				  			if(this.ifSuccessGetNum2&&this.ifSuccessGetNum1){
								
								this.setState({
									ifSuccessGet:true				
								})
							}else{
								this.setState({
									ifSuccessGet:false
									
								})
							}
				  		}else{
				  			
				  			this.ifSuccessGetNum1=true
				  			if(this.ifSuccessGetNum2&&this.ifSuccessGetNum1){
								
								this.setState({
									ifSuccessGet:true				
								})
							}else{
								this.setState({
									ifSuccessGet:false
									
								})
							}
  						}
  					}

  			})
  		
  	}
  	handleGetGift(){
  		this.setState({
			ifSuccessGet:false,
			showLoading:true				
		})
		
		var iPayNode =''
		var mVal = ''
		if(this.state.giftDetail.payMode===1){
			iPayNode=2
		}
		if(this.state.giftDetail.payMode===2){
			iPayNode=1
		}
		if(this.state.giftDetail.payMode===3){
			iPayNode=3
			mVal = this.state.couponNum
		}
  		this.caiGameId= this.props.match.params.id
  		var ifNewGame = this.props.ifNewGame?this.props.ifNewGame:''
  		var packId = this.props.packId?this.props.packId:''
  		
  		var zdata = {}
  		if(this.caiGameId==39){
			zdata = {
		 		 	
			 	num:this.state.price,
			 	payMode:iPayNode,
			 	coupon:mVal,
			 	newgame_id:ifNewGame,
			 	pack_id:packId
	 		}
		}else{
			if(this.state.platform===2){
	  			//var myUrl = 'fapi/users/getItem/'+this.props.giftData.id+'?area_id='+this.AreaId+'&role_name='+this.roleName+'&character_id='+this.character_id+'&equip='+this.state.equip+'&&num='+this.state.price+'&&payMode='+this.state.giftDetail.payMode+'&&score='+mVal+'&&newgame_id='+ifNewGame+''
				 zdata = {
				 	area_id:this.AreaId,
				 	role_name:encodeURIComponent(encodeURIComponent(this.roleName)),
				 	character_id:this.character_id,
				 	equip:this.state.equip,
				 	num:this.state.price,
				 	payMode:iPayNode,
				 	coupon:mVal,
				 	newgame_id:ifNewGame,
				 	pack_id:packId
				 }
  			}else{
  				zdata = {
				 	area_id:this.AreaId,			 	
				 	group_id:this.groupId,
				 	role_name:encodeURIComponent(encodeURIComponent(this.roleName)),
				 	character_id:this.character_id,			 	
				 	num:this.state.price,
				 	payMode:iPayNode,
				 	coupon:mVal,
				 	newgame_id:ifNewGame,
				 	pack_id:packId
			 	}
  			}
		}
		/*
  		if(this.state.platform===2){
  			//var myUrl = 'fapi/users/getItem/'+this.props.giftData.id+'?area_id='+this.AreaId+'&role_name='+this.roleName+'&character_id='+this.character_id+'&equip='+this.state.equip+'&&num='+this.state.price+'&&payMode='+this.state.giftDetail.payMode+'&&score='+mVal+'&&newgame_id='+ifNewGame+''
			 zdata = {
			 	area_id:this.AreaId,
			 	role_name:this.roleName,
			 	character_id:this.character_id,
			 	equip:this.state.equip,
			 	num:this.state.price,
			 	payMode:iPayNode,
			 	coupon:mVal,
			 	newgame_id:ifNewGame,
			 	pack_id:packId
			 }
  		}else{	
  			if(this.caiGameId==39){
  				zdata = {
				 		 	
				 	num:this.state.price,
				 	payMode:iPayNode,
				 	coupon:mVal,
				 	newgame_id:ifNewGame,
				 	pack_id:packId
			 	}
			 
  			}else {
  				zdata = {
				 	area_id:this.AreaId,			 	
				 	group_id:this.groupId,
				 	role_name:this.roleName,
				 	character_id:this.character_id,			 	
				 	num:this.state.price,
				 	payMode:iPayNode,
				 	coupon:mVal,
				 	newgame_id:ifNewGame,
				 	pack_id:packId
			 	}
  			}
			 
  			//var myUrl = 'fapi/users/getItem/'+this.props.giftData.id+'?area_id='+this.AreaId+'&group_id='+this.groupId+'&role_name='+this.roleName+'&character_id='+this.character_id+'&&num='+this.state.price+'&&payMode='+this.state.giftDetail.payMode+'&&score='+mVal+'&&newgame_id='+ifNewGame+''
  		}
  		*/
  		axios.get(
  			'/fapi/users/getItem/'+this.props.giftData.id,
	  			{
	  				params:zdata
	  			}
  		
  			)
  		.then((res)=>{
  			this.props.successCallBack&&this.props.successCallBack('1')
			this.setState({
	  			visible:false,
	  			showSelectWelfare:false,
	  			showGetSuccess:true,
	  			successMsg:res.data,
	  			showLoading:false
	  			
  			})
  			this.props.getGiftSuccessCallBack('1')
  			this.props.getSuccessCallBack&&this.props.getSuccessCallBack('1')
  			this.props.successCallBack&&this.props.successCallBack('1')
  			if(res.data.return_code===-301047){
  				
				this.setState({
					alertCode:true,
					alertNotice:false
				})
  				
				this.alertMsg = '领取失败'
  			}
  			if(res.data.return_code===-30103901){
  				this.ifPhone = false
  			}
  			if(res.data.return_code===0){
				this.props.getNewGameIndex()
				this.props.getUnReadNum()
				
				this.setState({
					alertNotice:true
				})
			
				this.alertMsg = '领取成功'
			//	this.props.getGiftSuccessCallBack('1') ///领取成功，通知回归页面刷新礼包
				axios.get('/fapi/checkLogin')
					.then(res=>{
						if(res.data.return_code===0){
						
							this.props.userList(res.data.data)
						}
					})
				
  			}
  			
  		})
  		
  	}
  	handleAffirmExchange(){
  		if(this.props.iStatus&&this.props.iStatus===3){
  			this.setState({
  				gradeLow:true,
  				visible:false,
  				showSelectWelfare:false
  			})
  			
  			
  		}else{
  			
			this.setState({
	  			visible:true,
	  			showSelectWelfare:false
	  		})
	  		this.handleArea()
  		}
		
  	}
  	affirmExchange(){
  		this.handleGetGift()
  		

  	}
	handleChangePrice(e){
		const mVal = e.target.options[e.target.options.selectedIndex].value
		var inum = this.comonPayMode(this.state.giftDetail,mVal).iPrice
		this.setState({
			price:mVal,
			giftTotalMoney:inum
			
		},function(){
			this.useScoreNum()
			this.userInp='1'
		})
	
		
	
	}
	useScoreNum(e){
		
		var mVal = e?e.target.value:''
		//this.userInp = mVal
		var num ='--'
		
		
		if(mVal){
			var num = (this.state.price*this.state.giftDetail.coupon-mVal)*this.state.giftDetail.score_exchange
			num = Math.ceil(num)
		}
		if(mVal&&parseInt(mVal)!==Number(mVal)){
			mVal=parseInt(mVal)
		}
		this.setState({
			userCoupon:num,
			couponNum:mVal,
			ScoreNotice:false,
			payType:e?3:this.state.payType
		},function(){

			this.checkPayType(this.state.payType)

		})

	}

	showScoreNotice(e){
		const mVal = e.target.value
		if(mVal<this.state.giftDetail.min_coupon*this.state.price||mVal>this.state.giftDetail.max_coupon*this.state.price){
			this.setState({
				ScoreNotice:true
			})
		}else{
			this.setState({
				ScoreNotice:false
			})
		}
	}
	handleMaxNum(num){
		var arr = []

		for(let i=0;i<num;i++){
			
			arr.push('<option key={i} value="'+(i+1)+'">'+(i+1)+'</option>')
		}
		return arr
	}
	
	checkPayType(num){
		
		this.state.giftDetail.payMode=num
		var imon = ''
		this.ifSuccessGetNum2 = true
		if(num===1){
			imon = this.state.giftDetail.coupon*this.state.price +'点券'
			
		}
		if(num===2){
			imon = this.state.giftDetail.score*this.state.price +'积分'
		}
		if(num===3){
			
			if(Number(this.state.userCoupon)>=0){

				imon = this.state.couponNum+
			'点券'+this.state.userCoupon+'积分'
			   
				
			}else{
				imon = '--点券--积分'
				
				
				this.ifSuccessGetNum2= false
			}
			
		}
		this.setState({
			giftTotalMoney:imon,
			payType:num
		})
		if(this.ifSuccessGetNum2&&this.ifSuccessGetNum1){
			
			this.setState({
				ifSuccessGet:true				
			})
		}else{
			this.setState({
				ifSuccessGet:false
				
			})
		}
		

		
	}
	alertMsgFn(){
		//this.state.alertNotice&&this.state.alertCode
		var str = ''
		if(this.state.alertNotice){
			str = '领取成功'
		}else if(this.state.alertCode){
			str='领取失败'
		}else{
			str = ''
		}
		
		return str 
	}
	payTypeFn(num){
		
		const idata = this.state.giftDetail
		var ib = ''
		if(idata.isCurrency==='1'){
			ib = 1
						
		}else{
			if(idata.isDota==='1'){
				ib =2
				
			}else{
				ib =3
				
			}
		}
		this.setState({
			payType:ib
		})

		this.checkPayType(ib)
				
	}
	render(){
		if(this.props.location.pathname.indexOf('return-detail')!==1){
			this.props.userlist.code?()=>getLoginURL(this.props.location.pathname):null 
		}
		
		const userlist = this.props.userlist?this.props.userlist:null
		  this.caiGameId= this.props.match.params.id
		return(

			<div>
				{
					this.state.showSelectWelfare&&<ToastBar num={'3'} 
						visible={this.state.showSelectWelfare} 
						title={this.props.iTitle?this.props.iTitle:'专属特权礼包'}  
						isOkShow ={false} 
						iTop={this.props.iTop}
						ToastBarClose={this.ToastBarClose}
					>
						

					{

						this.state.giftDetail&&<div className="welfare-gift-box">
				
							<div className="privilege-gift-header">
								<div className="privilege-gift-img" style={{backgroundImage:'url('+this.state.giftDetail.imgUrl+')'}}></div>
								<div className="privilege-gift-name">{this.state.giftDetail.title}</div>
								<div className="privilege-gift-integral">会员优惠价：<span>{this.comonPayMode(this.state.giftDetail,1).iPrice}</span></div>
							</div>
							<div className="wel-privilege-gift">
								<div className="wel-gift-introduce">礼包介绍</div>
								<div dangerouslySetInnerHTML={{ __html: this.state.giftDetail.description}}></div>
								<button className="wel-gift-btn" onClick={this.handleAffirmExchange.bind(this)}>立即兑换</button>
							</div>
						</div>
					}
				</ToastBar>
			}
				{
					this.state.visible&&<ToastBar num={'3'} 
						visible={this.state.visible} 
						title="礼包兑换"  
						isOkShow ={false} 
						iTop={this.props.iTop}
						ToastBarClose={this.ToastBarClose}
				 	>
						<div className="welfare-gift-select">
							<div className="my-integral">我的积分：<span>{userlist.scoreinfo.score}</span></div>
							<div className="welfare-gift-msg">
								<div>礼包信息</div>
								<div><span>礼包名称: </span><em>{this.state.giftDetail.title}</em></div>
								<div className="gift-price clearfix">
									<span>会员优惠价: </span>
									<em>{this.comonPayMode(this.state.giftDetail,1).iPrice}</em>
									<select 										
										onChange={(e)=>this.handleChangePrice(e)}										
									>
										{ 
											this.handleMaxNum(this.state.giftDetail.max_num).map((item,i)=>{
												return <option key={i} value={i+1}>{i+1}</option>
											})
											
										}
									</select>
								</div>
								<div className="total-price clearfix">
									总计：
									<span>{this.comonPayMode(this.state.giftDetail,this.state.price).iPrice}</span>
									
								</div>
								<div>兑换信息</div>
								<div><span>兑换账号: </span>{userlist.displayAccount}</div>
								<ul className="select-msg" style={this.caiGameId==39?{'display':'none'}:{'display':'block'}}>
									<li>
										{
											this.state.platform===2?
												<strong className="sel-strong1">选择平台:</strong>:
												<strong>兑换区:</strong>
												
										}
										
										<select onChange={(e)=>this.handleChangeArea(e)} >
											{
												this.state.platform===1&&this.state.getAreas&&this.state.getAreas.map((item,i)=>{
													

													return(
														<option key={i} _id={item.area_id} _platform={this.state.platform===2?(i+1):-1}>{item.area_name}</option>
													)
												})
											}
											{
												this.state.platform===2&&this.state.getAreas&&this.state.getAreas.map((item,i)=>{
													

													return(
														<option key={i} _id={item.area_id} _platform={this.state.platform===2?(i+1):-1}>{item.area_name}</option>
													)
												})
											}
																					
										</select>
									</li>
									<li>
										{
											this.state.platform===2?
												<strong>兑换服:</strong>:
												<strong>兑换服:</strong>
										}
										

										<select  key={this.state.solveFuNum} onChange={(e)=>this.handleChangeServer(e)}
												
											>
											{
												this.state.getServer&&this.state.getServer.map((item,i)=>{
													return(
														this.state.platform === 2 ? 
														<option key={i} _id={item.area_id} >{item.area_name}</option>:
														<option key={i} _id={item.id}>{item.title}</option>
		
													)
												})
											}

										</select>
									</li>
									<li>
										<strong>兑换角色:</strong>
										<select onChange={(e)=>this.handleChangeRole(e)}>
											{this.state.characterName&&this.state.characterName.map((item,i)=>{
												return(
													<option key={i} _name={item.character_name} _id={item.character_id}>{item.character_name}</option>
												)
											})}
											
										

										</select>
									</li>

								</ul>
								<div className="pay-type">
									<div>支付方式</div>
									<div>
										{
											this.state.giftDetail.isCurrency==1?<div className="pay-score">
												<input type="radio" 
													name="pay-select" 
													onClick={()=>this.checkPayType(1)}
													defaultChecked={this.state.payType===1?true:false}
												/>
												
												<span>{this.state.giftDetail.coupon*this.state.price+'点券'}</span>
											</div>:null
										}
										{
											this.state.giftDetail.isDota==1?<div className="pay-score">
												<input type="radio" 
													name="pay-select" 
													onClick={()=>this.checkPayType(2)}
													defaultChecked={this.state.payType===2?true:false}
												/>
												
												<span>{this.state.giftDetail.score*this.state.price+'积分'}</span>
											</div>:null
										}
										{
											this.state.giftDetail.isBoth==1?<div className="pay-coupon">
												<input type="radio"  name="pay-select" 
													
													checked={this.state.payType===3?true:false}
													onChange={()=>this.checkPayType(3)}
												/>
												总共支付：
												<input type="number" 
													onChange={(e)=>this.useScoreNum(e)}  
													onBlur={(e)=>this.showScoreNotice(e)}
													placeholder="输入点券金额"
													value={this.state.couponNum}


												/>
												点券，还需支付 <span>{this.state.userCoupon}</span> 积分
												{this.state.ScoreNotice&&<strong>( 请输入正确的点券值 )</strong>}
											</div>:null
											
										}
										{

											this.state.giftDetail.isBoth==1?<div>
												<div style={{textIndent:'40px'}}>
												    当前最大可用  <span>{this.state.giftDetail.max_coupon*this.state.price}</span> 点券
												最少可用  <span>{this.state.giftDetail.min_coupon*this.state.price}</span> 点券
											</div>
											

											</div>:null
										}
										
									
									</div>
									

	
								</div>
								<div className="exchange-integral clearfix">
									<span>支付：</span>
									<span>{this.state.giftTotalMoney}</span>
									
								</div>
								{
									this.state.ifSuccessGet||this.caiGameId==39?
									<button className="wel-gift-btn" onClick={()=>this.affirmExchange()}></button>:
									<button className="wel-gift-btn-2">确认兑换</button>
								}
								
								{
									this.state.showLoading&&<div className="wel-gift-btn-3">努力发货中...</div>
								}
							</div>
						</div>
						
				</ToastBar>
				}
				{

					this.state.showGetSuccess&&<ToastBar num={'3'} ToastBarClose={this.ToastBarClose} visible={this.state.showGetSuccess} title="领取提示"  isOkShow ={false} iTop={this.props.iTop}>
						<div className="success-notice">

						<div className="notice">{this.alertMsgFn()}</div>
							
						<div className="notice-msg-2">{this.state.successMsg.return_msg?this.state.successMsg.return_msg:'领取失败'}</div>
						{
							this.ifPhone?<a href="javascript:;">前往心享俱乐部网站查看订单信息</a>:
							<Link 
								style={this.state.alertNotice||this.state.alertCode?{'display':'block'}:{'display':'none'}} 
								to="/my-message">查看我的消息</Link>
						}
						
						
						</div>
					</ToastBar>
				}
				{
						this.state.gradeLow&&<ToastBar num={'3'} visible={this.state.gradeLow} title="等级不足提示"  isOkShow ={false} iTop={this.props.iTop}>
						<div className="success-notice">
							
						<div>礼包仅支持黄金以上会员领取</div>
						
						
						</div>
					</ToastBar>
				}
				
			</div>
				)
	}
}
export default GiftAlert


// WEBPACK FOOTER //
// ./src/component/gift-alert/gift-alert.js